var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDownXxsmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99967 7.40532C5.16409 7.40062 5.31441 7.33955 5.43654 7.20802L9.00663 3.55338C9.10997 3.45004 9.16634 3.31851 9.16634 3.16349C9.16634 2.85346 8.92207 2.60449 8.61204 2.60449C8.46172 2.60449 8.3161 2.66556 8.20805 2.7736L5.00437 6.06654L1.79129 2.7736C1.68325 2.67026 1.54233 2.60449 1.38731 2.60449C1.07728 2.60449 0.833008 2.85346 0.833008 3.16349C0.833008 3.31851 0.889378 3.45004 0.992722 3.55338L4.56751 7.20802C4.69434 7.33955 4.83526 7.40532 4.99967 7.40532Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownXxsmall);
export default __webpack_public_path__ + "static/media/chevron-down-xxsmall.bc2e2ee7.svg";
export { ForwardRef as ReactComponent };